import { buildSourceEntries, findSourceEntry } from '../../data.js';
import { inferColumns } from '../../fileIO.js';

// Columns for an Excel block's SELECTED Source, not the step's own live
// schema — mirrors JoinInspector's `rightCols`. Looked up in the same
// source list SourceSelect renders. Sheets and uploaded files carry
// `columns`; a step output doesn't, so best-effort infer them from its live
// preview rows in runMap, when available. Returns undefined for Self (or
// when nothing is known yet), which makes ColSelect fall back to the step's
// live schema via ColumnsContext.
export function sourceColumns(source, { sheets, secondaryDatasets, pipeline, runMap }) {
  if (!source || source === '__self__') return undefined;
  const entry = findSourceEntry(buildSourceEntries({ sheets, secondaryDatasets, steps: pipeline?.steps }), source);
  if (!entry) return undefined;
  if (entry.kind !== 'step') return entry.columns;
  const rows = runMap?.get(entry.step.id)?.rows;
  return rows?.length ? inferColumns(rows) : undefined;
}
